module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/header_images/header_2-cab3b37eed050c771e010dcb063affc6.svg";